import pageheader from "../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../utils/util";
import smsService from "../../../api/reservePlanNew.service";
import moment from "moment";
import rules from "../../../utils/rules";
import schedulerDialog from "@/components/SchedulerDialog";

import telematicsService from "../../../api/telematics.service";
export default {
  name: "off-rent-report",
  components: { pageheader, schedulerDialog },
  data() {
    return {
      input: {},
      reportsList: [],
      loadergetcalls: false,
      selected: [
        "Equipment",
        "Geofence",
        "Group",
        "Jobsite",
        "Model",
        "Search Field",
      ],
      selectedMachine: [],
      menufilter: false,
      filterTypes: [
        { id: "2", name: "Equipment" },
        { id: "3", name: "Geofence" },
        { id: "4", name: "Group" },
        { id: "5", name: "Jobsite" },
        { id: "6", name: "Model" },
        { id: "7", name: "Search Field" },
      ],

      nodataMachine: false,
      showmachinmsg: true,
      fromDate: "",
      toDate: new Date().toISOString().slice(0, 10),
      search: "",
      menu1: false,
      menu2: false,
      isReportExporting: false,
      isDownloading: false,

      showTable: true,
      isReportLoading: false,
      loadingMachines: false,
      machineSearchFilter: null,
      machines: [],
      zoneSearchFilter: "",
      groupSearchFilter: "",
      groups: [],
      selectedGroup: [],
      jobSiteSearchFilter: "",
      locations: [],
      jobSiteList: [],
      loadinglocations: false,
      selectedJobSite: [],
      selectedJobSiteNames: [],
      selectedZone: [],
      zonesList: [],
      modelSearchFilter: "",
      models: [],
      selectedModel: [],
      searchMenu: false,
      searchEquipName: "",
      searchPO: "",
      searchJob: "",
      searchContractId: "",
      header: [
        { text: "Access Control Code", value: "accessControlCode", sortable: true, width: "160px" },
        { text: "Equipment #", value: "itemKey" },
        { text: "Equipment", value: "itemName", width: "150px" },
        { text: "Customer Name", value: "customerName" },
        { text: "Due Date", value: "dateDue" },
        { text: "Contract #", value: "cntr" },
        { text: "Qty", value: "qty" },
        { text: "HP", value: "horsePower" },
        { text: "Status", value: "status" },
        { text: "Days Off Rent", value: "daysOffRent" },
        { text: "Date Out", value: "dateOut" },
        { text: "Days On Rent", value: "daysOnRent" },
        { text: "Jobsite", value: "jobsite", width: "150px" },
        { text: "Job #", value: "jobNo" },
        { text: "PO #", value: "poNo", width: "150px" },
        { text: "Ordered By", value: "orderedBy" },
        { text: "Picked Up By", value: "pickedupBy" },
        { text: "Contract Info", value: "contractInfo" },
      ],
      excelHeader: [],
      startrow: 4,
      smsCustomersList: [],
      selectedSMSCustomer: "",
      isCustLoad: false,
      csvName: "Off Rent.xlsx",
      pdfName: "Off Rent.pdf",
      isDownloadCSV: false,
      errorMSG: "",
      // scheduled reports data fields
      jobSiteSearchFilterSchedule: "",
      searchContractIdSchedule: "",

      searchemail: null,
      emailitems: [],
      emails: [],
      Scheduledheader: [
        { text: "Company", value: "customerName", width: "10px" },
        { text: "Name", value: "name", width: "10px" },
        { text: "Format", value: "format", width: "10px" },
        { text: "Frequency", value: "frequency", width: "10px" },
        { text: "Emails", value: "emails", width: "10px" },
        { text: "Action", value: "action", width: "10px" },
      ],
      pageNumber: 1,
      pageSize: 100,
      totalRecords: 0,
      totalRecordsCount: 0,
      scheduledFrequency: "",
      FrequencyListDropDown: ["Daily", "Weekly", "Biweekly", "Monthly"],
      scheduledTypeListDropdown: ["Excel", "PDF"],
      scheduledType: "",

      zoneSearchFilterSchedule: "",
      menufilterSchedule: false,
      modelSearchFilterSchedule: "",
      machineSearchFilterSchedule: null,
      groupSearchFilterSchedule: "",
      accessControlCodesSearchFilterSchedule: "",
      selectedOwnershipTypeSchedule: ["1", "2"],
      selectedOwnershipFinalSchedule: "",
      searchFieldSchedule: "",
      searchSchedule: "",
      ScheduleReportName: "OFFRENT",
      searchMenuSchedule: false,
      selectedschedule: {},
      scheduleedit: false,
      dailyUtilizationTargetSchedule: 0,
      selectedTimeSchedule: "Hours",
      selectedZonesNamesSchedule: [],
      selectedJobSiteNamesSchedule: [],
      selectedModelNamesSchedule: [],
      timeSearchFilterSchedule: "",
      selectedAccessControlCodesNamesSchedule: [],
      selectedGroupSchedule: [],
      selectedModelSchedule: [],
      selectedAccessControlCodesSchedule: [],
      selectedJobSiteSchedule: [],
      selectedMachineSchedule: [],
      selectedZoneSchedule: [],
      displayScheduledForm: false,
      scheduledialog: false,
      confirmdialog: false,
      isdelete: false,
      scheduleformvalid: true,
      isSaveScheduleLoading: false,
      isupdateScheduleLoading: false,
      scheduleName: "OFFRENT",
      selectedcust: "",
      scheduledList: [],
      isScheduledListLoading: false,
      ScheduledWeekDaysList: [
        {
          name: "Sunday",
          value: "0",
        },
        {
          name: "Monday",
          value: "1",
        },
        {
          name: "Tuesday",
          value: "2",
        },
        {
          name: "Wednesday",
          value: "3",
        },
        {
          name: "Thursday",
          value: "4",
        },
        {
          name: "Friday",
          value: "5",
        },
        {
          name: "Saturday",
          value: "6",
        },
      ],
      selectedDays: [],
      custnum: "",
      custid: "",
      custname: "",
      rules: rules,
      isRefreshingData: false,
      selectedExportOption: null,
      exportOptions: ["Excel", "PDF"],
      closeOnContentClick: false,
      // end scheduled reports data fields
    };
  },
  computed: {
    ...mapGetters([
      "roles",
      "smsCNum",
      "smsCustomerId",
      "smsUserId",
      "smsCustomerLinkingId",
      "companyNameDropdown",
      "companyIdDropdown",
    ]),
  },
  watch: {
    machineSearchFilter(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
    machineSearchFilterSchedule(val) {
      if (val != undefined && val.length % 2 == 0) {
        this.searchMachines(val);
      }
    },
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        const format = "MM/DD/YYYY";
        return moment(value).format(format);
      }
    },
    formatTimeStamp: function (val) {
      return moment.utc(val * 1000).format("HH:mm:ss");
    },
  },
  async mounted() {
    this.input = utils.getInputContent("offRentReport", this.roles);

    if (
      this.$store.getters.companyIdDropdown == null ||
      this.$store.getters.companyIdDropdown == "" ||
      this.$store.getters.companyIdDropdown == undefined
    ) {
      this.errorMSG = "Please select customer to run the report";
      this.showTable = false;
    } else {
      this.errorMSG = "";
      this.showTable = true;
      this.getReportList();
      this.loadergetcalls = false;

      await this.getGroups();
      await this.getLocations();
      await this.getModels();
      await this.getZones();
      this.loadergetcalls = true;
    }
    // get reports list on page load without any filter
  },
  methods: {
    getList(item, queryText, itemText) {
      return itemText
        .toLocaleLowerCase()
        .startsWith(queryText.toLocaleLowerCase().trim());
    },
    mindate() {
      return new Date(new Date().setFullYear(new Date().getFullYear() - 1))
        .toISOString()
        .slice(0, 10);
    },
    maxdate() {
      return new Date().toISOString().slice(0, 10);
    },
    async getReportList(isRefresh) {
      this.isRefreshingData = true;
      if (isRefresh) {
        this.reportsList = [];
      } else {
        this.isReportLoading = true;
      }

      try {
        let response = await smsService.getOffRentReport(
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response && response.isSuccess) {
          this.showTable = true;
          this.reportsList = response.data;

          this.isReportLoading = false;
          this.isRefreshingData = false;
        } else {
          this.reportsList = [];
          this.isReportLoading = false;
          this.isRefreshingData = false;
        }
      } catch (err) {
        console.log(err);
        this.isReportLoading = false;
        this.isRefreshingData = false;
      }
    },
    clearFilters() {
      this.fromDate = "";
      this.toDate = new Date().toISOString().slice(0, 10);
      this.reportsList = [];
      this.selectedGroup = [];
      this.selectedMachine = [];
      this.selectedModel = [];
      this.selectedZone = [];
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
      this.searchEquipName = "";
      this.searchPO = "";
      this.searchJob = "";
      this.searchContractId = "";
      this.getReportList();
    },
    async downloadReport(exportOption) {
      try {
        let response = await smsService.exportOffRentReport(
          exportOption,
          this.selectedMachine,
          this.selectedZone,
          this.selectedGroup,
          this.selectedJobSiteNames,
          this.selectedModel,
          this.searchEquipName,
          this.searchPO,
          this.searchJob,
          this.searchContractId
        );
        if (response) {
          if (exportOption == this.exportOptions[0]) {
            //excel
            utils.downloadExcelFile(response, this.csvName);
          } else {
            //pdf
            utils.downloadPDFFile(response, this.pdfName);
          }
        } else {
          this.$toast.error(
            "Unable to download the report. Please contact admin."
          );
        }
        this.isDownloading = false;
      } catch (error) {
        this.$toast.error(
          "Unable to download the report. Please contact admin."
        );
        this.isDownloading = false;
      }
    },
    // scheduled reports api calls

    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    clearTimeFrame() {
      this.scheduledtimeframe = "";
    },
    showScheduledForm() {
      this.scheduleedit = false;
      this.clearSchedule();
      this.displayScheduledForm = true;
    },
    cancelSchedule() {
      this.displayScheduledForm = false;
      this.scheduleedit = false;

      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledType = "";

      this.searchFieldSchedule = "";
      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    closeSchedule() {
      this.scheduledialog = false;
      this.clearSchedule();
    },
    clearSchedule() {
      this.selectedschedule = {};
      this.scheduleName = "";
      this.emails = [];
      this.scheduledFrequency = "";
      this.scheduledType = "";

      this.selectedTimeSchedule = "Hours";
      this.dailyUtilizationTargetSchedule = 0;
      this.searchContractIdSchedule = "";
      this.selectedDays = [];
    },
    EditScheduleDialog(item) {
      this.scheduleedit = true;
      this.selectedschedule = item;
      this.scheduleName = item.name;
      this.selectedcust = item.customerName;
      this.emails = item.emails.split(",");
      this.selectedDays =
        item.weekDays != null && item.weekDays != ""
          ? item.weekDays.split(",")
          : [];
      this.scheduledFrequency = item.frequency;
      this.scheduledType = item.format;
      this.displayScheduledForm = true;
      // filters

      item.parameters.filter((e) => {
        if (e.name == "custid" && e.value != "") {
          this.custid = e.value;
        }
        if (e.name == "custnum" && e.value != "") {
          this.custnum = e.value;
        }
        if (e.name == "custname" && e.value != "") {
          this.custname = e.value;
        }
      });

      //end filters
    },
    async CreateSchedule() {
      this.isSaveScheduleLoading = true;

      let id, cust;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        cust = "";
        id = "";
      } else {
        cust = this.$store.getters.companyNameDropdown;
        id = this.$store.getters.companyIdDropdown;
      }

      let parameters = [
        {
          name: "custid",
          value: String(this.smsUserId),
        },
        {
          name: "custnum",
          value: this.smsCustomerLinkingId,
        },
        { name: "custname", value: this.companyNameDropdown },
      ];
      let emails = this.emails.map((e) => e.trim());
      let payload = {
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),
        customerName: cust,
        name: this.scheduleName,
        emails: emails.join(","),
        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,

        format: this.scheduledType,
      };

      try {
        let response = await telematicsService.createScheduledReport(payload);
        if (response.isSuccess) {
          this.isSaveScheduleLoading = false;
          this.$toast.success(" Schedule report  created successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isSaveScheduleLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isSaveScheduleLoading = false;
      }
    },
    async UpdateSchedule() {
      this.isupdateScheduleLoading = true;

      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }

      let parameters = [
        {
          name: "custid",
          value: String(this.custid),
        },
        {
          name: "custnum",
          value: this.custnum,
        },
        {
          name: "custname",
          value: this.custname,
        },
      ];

      let emails = this.emails.map((e) => e.trim());
      let payload = {
        id: this.selectedschedule.id,
        reportId: this.ScheduleReportName,
        parameters: parameters,
        customer: String(id),
        customerName: this.selectedcust,
        name: this.scheduleName,
        emails: emails.join(","),
        weekDays:
          this.selectedDays.length != 0 ? this.selectedDays.toString() : null,
        frequency: this.scheduledFrequency,
        format: this.scheduledType,
      };

      try {
        let response = await telematicsService.updateScheduledReport(
          this.selectedschedule.id,
          payload
        );
        if (response.isSuccess) {
          this.isupdateScheduleLoading = false;
          this.$toast.success(" Schedule report  updated successfully");
          this.displayScheduledForm = false;
          this.getScheduledList();
        } else {
          this.isupdateScheduleLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isupdateScheduleLoading = false;
      }
    },
    async getScheduledList() {
      this.isScheduledListLoading = true;
      let id;
      if (
        this.companyIdDropdown == "" ||
        this.companyIdDropdown == null ||
        this.companyIdDropdown == undefined
      ) {
        id = "";
      } else {
        id = this.$store.getters.companyIdDropdown;
      }
      try {
        let response = await telematicsService.getScheduledReportList(
          String(id),
          String(this.ScheduleReportName)
        );

        if (response.isSuccess) {
          this.isScheduledListLoading = false;
          this.scheduledList = response.data;
        } else {
          this.isScheduledListLoading = false;
        }
      } catch (err) {
        console.log(err);
        this.isScheduledListLoading = false;
      }
    },
    confirmDelete(item) {
      this.confirmdialog = true;
      this.selectedschedule = item;
    },
    async deleteSchedule() {
      try {
        this.isdelete = true;
        let response = await telematicsService.deleteSchedule(
          this.selectedschedule.id
        );
        if (response.isSuccess) {
          this.isdelete = false;
          this.$toast.success("Deleted Schedule report successfully");
          this.clearSchedule();
          this.displayScheduledForm = false;
          this.getScheduledList();
          this.confirmdialog = false;
          this.selectedschedule = {};
        } else {
          this.isdelete = false;
          this.$toast.success(response.systemMessage);
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete Schedule report" + err);
      }
    },
    OnFrequencyChange() {
      this.selectedDays = [];
    },
    async searchMachines(value) {
      let machineValue = "";
      machineValue = encodeURIComponent(value);
      this.machines = [];
      try {
        this.loading = true;
        let response = await telematicsService.getTelematicMachinesnew(
          machineValue
        );
        if (response && response.data.length != 0) {
          this.machines = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              tuUnitId: item.tuUnitId ? item.tuUnitId : "",
              machine: String(index),
              stockKey: item.stockKey ? item.stockKey : "",
            };
          });
          this.loading = false;
        } else {
          this.nodataMachine = true;
          this.showmachinmsg = false;
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        this.nodataMachine = true;
        this.showmachinmsg = false;
        console.log(err);
      }
    },
    async getZones() {
      try {
        let response = await telematicsService.getZones();
        if (response && response.data) {
          this.zonesList = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",
              Zone: String(index),
            };
          });
        } else {
          this.zonesList = [];
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getGroups() {
      try {
        this.loading = true;
        let response = await telematicsService.getGroups();
        if (response) {
          this.groups = response.data.map((item, index) => {
            return {
              name: item.name ? item.name : "",
              id: item.id ? item.id : "",

              group: String(index),
            };
          });

          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async getLocations() {
      try {
        this.loadinglocations = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = this.locations = response.data.filter(
            (e) => e.locationName != null
          );
          this.loadinglocations = false;
        }
      } catch (err) {
        this.loadinglocations = false;
        console.log(err);
      }
    },
    async getModels() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data.map((item, index) => {
            return {
              name: item ? item : "",
              id: item ? item : "",

              model: String(index),
            };
          });

          this.loadingmodel = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    jobSiteChange() {
      this.selectedJobSiteNames = [];
      this.selectedJobSiteNames = this.selectedJobSite.map(
        (locationId) =>
          this.locations.find((el) => el.locationId == locationId).locationName
      );
    },
    async getJobSites() {
      try {
        this.loadingmodel = true;
        let response = await telematicsService.getLocations();
        if (response.isSuccess) {
          this.jobSiteList = response.data.filter(
            (e) => e.locationName != null
          );
        } else {
          this.jobSiteList = [];
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    clearDates() {
      if (this.fromDate) {
        this.fromDate = "";
      }
      if (this.toDate) {
        this.toDate = "";
      }
    },
    resetGroup() {
      this.selectedGroup = [];
    },
    resetMachine() {
      this.selectedMachine = [];
    },
    resetZone() {
      this.selectedZone = [];
    },
    resetJobSite() {
      this.selectedJobSite = [];
      this.selectedJobSiteNames = [];
    },
    resetModel() {
      this.selectedModel = [];
    },
    clearSearchEquipName() {
      this.searchEquipName = "";
    },
    clearSearch() {
      this.searchPO = "";
    },
    clearSearchContractId() {
      this.searchContractId = "";
    },
    exportIconClick(item) {
      this.selectedExportOption = item;
      if (this.selectedExportOption) {
        this.isDownloading = true;
        //case  "excel"
        if (this.selectedExportOption == this.exportOptions[0]) {
          this.downloadReport(this.exportOptions[0]);
        } else if (this.selectedExportOption == this.exportOptions[1]) {
          //case  "Pdf"
          this.downloadReport(this.exportOptions[1]);
        }
      }
    },
    openScheduledDialog() {
      this.$refs.modal.showScheduleModal();
    },
    // end scheduled reports methods
  },
};
